import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { siteInfo } from '@/mocks/site';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-900 text-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="py-14 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-12">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-heading font-bold text-lg">
                  伦
                </div>
                <span className="font-heading text-lg font-semibold text-background-50">
                  {siteInfo.name}
                </span>
              </Link>
              <p className="text-sm text-background-300 leading-relaxed">
                {siteInfo.tagline}
              </p>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                {t('section_categories')}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                快速链接
              </h4>
              <ul className="flex flex-col gap-2.5">
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                  >
                    {t('nav_about')}
                  </Link>
                </li>
                <li>
                  <Link
                    to="/category/ethical-theory"
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                  >
                    伦理理论
                  </Link>
                </li>
                <li>
                  <Link
                    to="/category/case-analysis"
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                  >
                    案例分析
                  </Link>
                </li>
                <li>
                  <Link
                    to="/category/ethics-assessment"
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                  >
                    伦理测评
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                联系方式
              </h4>
              <ul className="flex flex-col gap-2.5">
                <li className="flex items-center gap-2 text-sm text-background-300">
                  <i className="ri-mail-line text-base"></i>
                  <span>{siteInfo.email}</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-background-300">
                  <i className="ri-phone-line text-base"></i>
                  <span>{siteInfo.phone}</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-background-300">
                  <i className="ri-map-pin-line text-base mt-0.5"></i>
                  <span className="leading-relaxed">{siteInfo.address}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="py-5 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">{t('copyright')}</p>
          <div className="flex items-center gap-4">
            <a
              href="#"
              className="text-xs text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
              rel="nofollow"
            >
              隐私政策
            </a>
            <a
              href="#"
              className="text-xs text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
              rel="nofollow"
            >
              使用条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}